var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruthful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.482,29.311c0-0.762-0.616-1.379-1.379-1.379c-0.159,0-0.306,0.041-0.447,0.09l-0.004-0.009  c-11.445,2.275-31.963,24.459-31.963,24.459l-8.913-3.708c-0.23-0.089-0.479-0.143-0.742-0.143c-1.144,0-2.069,0.927-2.069,2.069  c0,0.62,0.278,1.169,0.708,1.549l9.767,8.368c0.348,0.264,0.777,0.428,1.249,0.428c0.639,0,1.203-0.296,1.583-0.75  c0,0,20.104-26.192,31.338-29.697c0.015-0.006,0.03-0.01,0.045-0.016c0.007-0.002,0.014-0.005,0.021-0.008l-0.001-0.004  C84.148,30.341,84.482,29.867,84.482,29.311z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.734,38.965c-7.428,6.07-16.705,16.71-22.18,23.839l-0.053,0.067l-0.055,0.064c-1.187,1.421-2.92,2.236-4.758,2.236  c-1.364,0-2.664-0.442-3.759-1.278l-0.093-0.072l-0.089-0.075l-9.808-8.402c-1.343-1.182-2.113-2.878-2.113-4.655  c0-3.422,2.784-6.207,6.207-6.207c0.758,0,1.51,0.141,2.232,0.42l0.05,0.02l0.05,0.021l6.281,2.614  c2.407-2.492,6.582-6.652,11.387-10.806V10H38.965v28.965H10v22.069h28.965V90h22.069V61.034H90V38.965H77.734z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruthful);
export default __webpack_public_path__ + "static/media/truthful.c90a19c7c642b4e2f8b498c601bffa08.svg";
export { ForwardRef as ReactComponent };